import {useRouteLoaderData} from '@remix-run/react'
import clsx from 'clsx'
import type {FunctionComponent} from 'react'
import {useState} from 'react'
import {getDomainConfig} from '~/domains'
import {useReportWidgetClick, useReportWidgetSeen} from '~/hooks/analytic-hooks'
import {IconChevronRightThick} from '~/icons/brg-icon-chevron-right-thick'
import {getTranslation} from '~/localization/translation'
import type {RootLoaderResponse} from '~/types'

interface RankSectionProps extends React.HTMLAttributes<HTMLDivElement> {}

const RankSection: FunctionComponent<RankSectionProps> = ({...attributes}) => {
  const {language, deviceType, domain, locale} = useRouteLoaderData('root') as RootLoaderResponse
  const translations = getTranslation(language)
  const [isRankSectionOpen, setIsRankSectionOpen] = useState(false)
  const {styles: stylesBydomain} = getDomainConfig(domain, locale)
  const device = deviceType === 'smartphone' ? 'mobile' : 'desktop'

  const reportClick = useReportWidgetClick()

  const [widgetRef] = useReportWidgetSeen({
    widget_name: 'engaging-rank-section',
    widget_place: 'middle',
  })

  return (
    <div {...attributes}>
      <div ref={widgetRef}>
        <button
          type="button"
          onClick={() => {
            setIsRankSectionOpen(!isRankSectionOpen)
            reportClick({
              widget_name: 'engaging-key-section',
              widget_place: 'middle',
              trigger_type: isRankSectionOpen ? 'expand-button-close' : 'expand-button-open',
            })
          }}
          aria-label="expand-rank-section"
          className={clsx(
            'border-gray relative z-20 flex h-full w-full flex-row items-center justify-center gap-3',
            'rounded-xl border bg-white text-center text-base font-medium shadow',
            'transition-all duration-200 ease-in-out',
            'py-3 tablet:py-2 tablet:text-sm',
          )}
        >
          {translations.RankSection.title}
          <IconChevronRightThick
            className={clsx(
              'size-4 fill-black transition-all duration-200 ease-in-out',
              isRankSectionOpen ? '-rotate-90' : 'rotate-90',
            )}
          />
        </button>
      </div>

      {isRankSectionOpen ? (
        <div
          className={clsx(
            'mx-auto mt-6 overflow-hidden',
            `${stylesBydomain.UTILS_MAIN_CONTAINER} utils_main_container`,
          )}
        >
          <div className="flex min-h-min flex-col justify-center gap-2 rounded-xl bg-gradient-to-r from-pink-100 to-fuchsia-100 p-5 mobile:justify-start mobile:p-3 mobile:text-start">
            <span className="flex justify-center text-center text-[20px] font-bold tracking-wide mobile:justify-start mobile:text-start mobile:text-base">
              {translations.RankSection.contentTitle}
            </span>
            <div className="flex flex-col justify-center text-center">
              <p className="text-base font-normal leading-6 tracking-normal desktop:px-2 tablet:mt-0 mobile:text-start mobile:text-[15px]">
                {translations.RankSection.contentDescription}
              </p>
              <div className="mx-auto flex h-auto max-w-[480px] shrink-0 grow-0 items-center justify-center">
                <img
                  src={`https://dt47coepsakuj.cloudfront.net/images/${device}/how-do-we-rank.png`}
                  alt="headphones-stars"
                  loading="lazy"
                  className="h-full w-full object-contain"
                />
              </div>
            </div>
          </div>
        </div>
      ) : null}
    </div>
  )
}

export default RankSection
